module.exports = __webpack_public_path__ + "img/close_icon.6b82102b.svg";